import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Toast, ToastrService } from 'ngx-toastr';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ContactPersoon, Land, Titulatuur } from 'src/app/shared/model/relatie';

@Component({
  selector: 'app-contactpersonenedit',
  templateUrl: './contactpersonenedit.component.html',
  styleUrls: ['./contactpersonenedit.component.less']
})
export class ContactpersoneneditComponent implements OnInit {


  @Input() id : number;
  contactpersoon: ContactPersoon;
  titulatuur : Array<Titulatuur>
  landen : Array<Land>
  relatieid = 0;

  constructor(
    private relatieService :RelatiesService,
    private activatedRoute : ActivatedRoute,
    private toastr : ToastrService

  ) { }

  ngOnInit() {
    const id = Number(this.activatedRoute.snapshot.paramMap.get('id'));
    const relatieid  = Number(this.activatedRoute.snapshot.paramMap.get('relatieid'));
    if (relatieid) {
      this.relatieid = relatieid;
      this.contactpersoon = new ContactPersoon();
      this.contactpersoon.ID = 0;
    } else {
      if (id) this.id = id;
      this.relatieService.getContactpersoon(this.id).subscribe(data=> {
        if (data == null) {
          this.contactpersoon = new ContactPersoon();
          return;
        }
        this.contactpersoon = data;
      })
    }
    this.relatieService.getTitulatuur().subscribe(data => {
      this.titulatuur =data;
    })
    this.relatieService.getLanden().subscribe(data => {
      this.landen =data;
    })
  }

  save() {
    if (this.contactpersoon.ID == 0 || this.contactpersoon.ID == undefined) {
      this.relatieService.addContactpersoon(this.contactpersoon).subscribe((data) => {
          if (!data) return;
          if (data.error) {
            this.toastr.error("",data.error.originalError.info.message)
            return;
          }
          this.contactpersoon.ID = data.ID ;
          this.contactpersoon.IsActief = 1;
          this.relatieService.addContactpersoonToRelatie(this.contactpersoon.ID,this.relatieid).subscribe((data) => {
            this.toastr.info("","Opgeslagen")
          });
      }
      );;

    } else {
      this.relatieService.saveContactpersoon(this.contactpersoon).subscribe(() => {
        this.toastr.info("", "Opgeslagen");
      }
      );;
    }
  }

  maakactief() {
    this.contactpersoon.IsActief = 1;
    this.save();
  }

  maakonactief() {
    this.contactpersoon.IsActief = 0;
    this.save();
  }
}
